<template>
  <div class="description_block">
    <div class="left_dm">
      <img class='base_image' src='@/assets/image/pages/top/left.png'>
      <img class='base_image pc_none' src='@/assets/image/pages/top/right.png'>
    </div>

    <div class="middle_dm">
      <h2 class="large_black_label">「スキル」×「時間」でマッチングする新感覚の受発注プラットフォーム</h2>
      <h2 class="large_black_label">もう作業者探し、予定調整に時間を取られることはありません。</h2>
      <div>
        <div class="left">
          <h3 class="client_label">クライアントの方へ</h3>
          <p>短時間※・単発のCAD作図業務を思い立ったらすぐ発注。</p>
          <p class="small_label">※作業の見込み時間が8時間以下の案件を発注できます。</p>
        </div>
        <div class="right">
          <h3 class="operator_label">オペレーターの方へ</h3>
          <p>家事・育児の合間の数時間だけ、設計者都合で予定業務が延期になったその日だけ…</p>
          <p>あなたのCADスキルを活かしてお仕事ができます。</p>
        </div>
      </div>

      <router-link class="link-underline_label" :to="{name: 'AboutSkills'}">登録スキルについて</router-link>
    </div>

    <div class="right_dm sp_none">
      <img class='base_image' src='@/assets/image/pages/top/right.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DescriptionBlock",
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 768px) {
    .description_block {
      display: flex;
      margin: 2rem 0;

      > .right_dm, > .left_dm {
        width: 300px;
      }

      > .middle_dm {
        display: flex;
        flex-flow: column;
        align-items: center;
        width: 60%;

        > div {
          @include double_columns(40%, 40%);
          margin: 2rem 0;
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    .description_block {
      display: flex;
      flex-flow: column;
      margin: 2rem 0;

      > .left_dm {
        display: flex;
        > .base_image {
          max-width: 50%;
          max-height: 30rem;
        }
      }

      > .middle_dm {
        display: flex;
        flex-flow: column;
        align-items: center;
        margin: 4rem 0;

        > div {
          @include double_columns(40%, 40%);
          margin: 2rem 0;
        }
      }
    }
  }
</style>